import styled from '@mui/system/styled';

export const ToolTipCloseButton = styled('button')(() => ({
  border: 'none',
  backgroundColor: 'transparent',
  cursor: 'pointer',
}));
